import { ReactNode } from 'react';

import { FlexBox } from '@sternum/styled-system';
import { Text12SB } from '@sternum/ui';
import { Icon } from '@sternum/web/components/Icon';

import { SummaryItemName, SummaryItemStyled } from './SummaryItems.styles';

export interface SummaryItemProps {
  renderIcon?: () => ReactNode;
  renderName?: (args: { NameComponent: typeof SummaryItemName }) => ReactNode;
  renderValue?: (args: { ValueComponent: typeof Text12SB }) => ReactNode;
  children?: ReactNode;
}

export function SummaryItem({
  renderIcon = () => (
    <Icon
      type="Check2ColorfulIcon"
      color={{ Dark: 'BlueMiddle', Light: 'BlueMiddle' }}
      color2={{ Dark: 'BlueLightest', Light: 'BlueLightest' }}
    />
  ),
  renderName = ({ NameComponent }: { NameComponent: typeof SummaryItemName }) => <NameComponent />,
  renderValue = ({ ValueComponent }: { ValueComponent: typeof Text12SB }) => <ValueComponent />,
  children,
  ...props
}: SummaryItemProps) {
  return (
    <SummaryItemStyled {...props}>
      <FlexBox alignItems="center" gap={8} overflow="hidden">
        {renderIcon()}
        {renderName({ NameComponent: SummaryItemName })}
      </FlexBox>
      {renderValue({ ValueComponent: Text12SB })}
      {children}
    </SummaryItemStyled>
  );
}
